import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { LISTING_STATE_DRAFT, LISTING_STATE_PENDING_APPROVAL } from '../../util/types';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  createSlug,
} from '../../util/urlHelpers';
import { H3, Form, Button, NamedLink } from '../../components';

import css from './EditListingPreviewPanel.module.css';

const EditListingPreviewPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const id = listing?.id?.uuid;
  const { title = '', state } = listing?.attributes || {};
  const slug = createSlug(title);

  const isPendingApproval = state === LISTING_STATE_PENDING_APPROVAL;
  const isDraft = state === LISTING_STATE_DRAFT;
  const variant = isPendingApproval
    ? LISTING_PAGE_PENDING_APPROVAL_VARIANT
    : isDraft
    ? LISTING_PAGE_DRAFT_VARIANT
    : null;

  return (
    <div className={classes}>
      <H3 as="h1">
        <FormattedMessage id="EditListingPreviewPanel.title" />
      </H3>

      <FinalForm
        onSubmit={() => onSubmit({})}
        render={formRenderProps => {
          const { handleSubmit } = formRenderProps;
          const { updateListingError, showListingsError } = errors || {};
          const submitReady = (panelUpdated) || ready;
          const submitInProgress = updateInProgress;
          const submitDisabled = disabled || submitInProgress;

          return (
            <Form className={css.form} onSubmit={handleSubmit}>
              {updateListingError ? (
                <p className={css.error}>
                  <FormattedMessage id="EditListingPreviewPanel.updateFailed" />
                </p>
              ) : null}
              {showListingsError ? (
                <p className={css.error}>
                  <FormattedMessage id="EditListingPreviewPanel.showListingFailed" />
                </p>
              ) : null}

              <div className={css.previewLink}>
                <NamedLink
                  name={variant ? 'ListingPageVariant' : 'ListingPage'}
                  params={{ id, slug, variant }}
                  target="_blank"
                >
                  <FormattedMessage id="EditListingPreviewPanel.previewLink" />
                </NamedLink>
              </div>

              <Button
                className={css.submitButton}
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
                ready={submitReady}
              >
                {submitButtonText}
              </Button>
            </Form>
          );
        }}
      />
    </div>
  );
};

export default EditListingPreviewPanel;
